import { useTranslation } from "react-i18next"

import { MultiSelectDropdown } from "./multi-select-dropdown"
import {
  BUSINESS_PAINS,
  ENTERPRISE_FUNCTIONS,
  STRATEGIC_ALIGNMENTS,
} from "../../types/use-case.types"

type FactSheetCategoriesProps = {
  bpSel: string[]
  saSel: string[]
  efSel: string[]
  onChange: (field: string, value: string[]) => void
}

const bpOptions = BUSINESS_PAINS.map((bp) => ({ value: bp, label: bp }))
const saOptions = STRATEGIC_ALIGNMENTS.map((sa) => ({ value: sa.value, label: sa.label }))
const efOptions = ENTERPRISE_FUNCTIONS.map((ef) => ({ value: ef, label: ef }))

export function FactSheetCategories({ bpSel, saSel, efSel, onChange }: FactSheetCategoriesProps) {
  const { t } = useTranslation()

  return (
    <div className="bg-card rounded-lg border p-4 shadow-sm">
      <div className="grid grid-cols-3 gap-4">
        <div>
          <label className="text-muted-foreground mb-1 block text-xs font-semibold tracking-wide uppercase">
            {t("useCases.factSheet.categories.businessPain")}
          </label>
          <MultiSelectDropdown
            options={bpOptions}
            placeholder="Select pain points..."
            selected={bpSel}
            onChange={(v) => onChange("bpSel", v)}
          />
        </div>
        <div>
          <label className="text-muted-foreground mb-1 block text-xs font-semibold tracking-wide uppercase">
            {t("useCases.factSheet.categories.strategicAlignment")}
          </label>
          <MultiSelectDropdown
            options={saOptions}
            placeholder="Select alignment..."
            selected={saSel}
            onChange={(v) => onChange("saSel", v)}
          />
        </div>
        <div>
          <label className="text-muted-foreground mb-1 block text-xs font-semibold tracking-wide uppercase">
            {t("useCases.factSheet.categories.enterpriseFunction")}
          </label>
          <MultiSelectDropdown
            options={efOptions}
            placeholder="Select function(s)..."
            selected={efSel}
            onChange={(v) => onChange("efSel", v)}
          />
        </div>
      </div>
    </div>
  )
}
